import apiClient from '../client';
import type { Daycare, CreateDaycarePayload, UpdateDaycarePayload } from '@/types';

export const daycaresApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get<{ data: Daycare[] }>('/daycares', { params }).then((r) => r.data.data),

  getById: (id: number) =>
    apiClient.get<{ data: Daycare }>(`/daycares/${id}`).then((r) => r.data.data),

  create: (payload: CreateDaycarePayload) =>
    apiClient.post<{ data: Daycare }>('/daycares', payload).then((r) => r.data.data),

  update: (id: number, payload: UpdateDaycarePayload) =>
    apiClient.put<{ data: Daycare }>(`/daycares/${id}`, payload).then((r) => r.data.data),

  remove: (id: number) =>
    apiClient.delete(`/daycares/${id}`),
};

